import React, { Component } from 'react';
import Head from '../../../../components/Head/Head';
import Auxiliary from '../../../../hoc/Auxiliary/Auxiliary';
import { withTranslation } from 'react-i18next';
import OutsourcingProviderBanner from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingProvider/OutsourcingProviderBanner/OutsourcingProviderBanner';
import OutsourcingProvider2 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingProvider/OutsourcingProvider2/OutsourcingProvider2';
import OutsourcingProvider3 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingProvider/OutsourcingProvider3/OutsourcingProvider3';
import OutsourcingProvider4 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingProvider/OutsourcingProvider4/OutsourcingProvider4';
import OutsourcingProvider5 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingProvider/OutsourcingProvider5/OutsourcingProvider5';

class OutsourcingProvider extends Component {
    render() {
        return (
            <Auxiliary>
                <Head id="outsourcing-provider" />
                <OutsourcingProviderBanner {...this.props} />
                <OutsourcingProvider2 {...this.props} />
                <OutsourcingProvider3 {...this.props} />
                <OutsourcingProvider4 {...this.props} />
                <OutsourcingProvider5 {...this.props} />
                <div className='custom-end-outsourcing-provider'></div>
            </Auxiliary>
        );
    }
}

export default withTranslation()(OutsourcingProvider);
